<template>
    <div class="dat-wrapper">
        <depositRenderData :data="savingAccountData" :viewButtonText="viewButtonText" :bankHealth="bankHealth" :hasError="hasError" />
    </div>
</template>
<script>
    import depositRenderData from './deposit-render-data.vue';
    import depositPaymentHelper from '~/helpers/deposit-account-api';

    export default {
        props: ['viewButtonText', 'bankHealth'],
        data() {
            return {
                savingAccountData: [],
                hasError: false,
            };
        },
        components: {
            depositRenderData,
        },
        async mounted() {
            await depositPaymentHelper.depositAccountData('lt-rt-sav').then((response) => {
                if (response.status === true) {
                    this.savingAccountData = response.data;
                } else {
                    this.hasError = true;
                }
            });
        },
    };
</script>
